wbApp.directive('wbHolidayCalendarWithAddCombo', [
    function () {

        return {
            restrict: 'A',
            priority: 1,
            scope: {
                ngModel: '='
            },
            template:
                '<div class="input-group">' +
                '    <input wb-holiday-calendar-combo class="form-control" ng-model="ngModel">' +
                '    <span class="input-group-btn">' +
                '        <button class="btn btn-default btn-wb-addon" ng-disabled="disableAddBtn"  ng-click="onAddClick()" type="button"><i class="fa fa-plus" aria-hidden="true"></i></button>' +
                '    </span>' +
                '</div>',
            controller: ['$scope', '$modal', 'securitySvc', 'holidayCalendarSvc',
                function ($scope, $modal, securitySvc, holidayCalendarSvc) {

                    $scope.disableAddBtn = !securitySvc.isInRole('HolidayCalendar.Insert')

                    $scope.onAddClick = function () {
                        detailDialogPromise.$promise.then(function () {
                            detailDialogPromise.$scope.model = holidayCalendarSvc.createNew();

                            detailDialogPromise.$scope.onDataSave = function (data) {
                                if (!!data) {
                                    $scope.ngModel = data.id;
                                }
                            };
                            detailDialogPromise.show();
                        });
                    }

                    var detailDialogPromise = $modal({
                        templateUrl: 'setting/holiday-calendars/holiday-calendars-detail.html',
                        show: false,
                        scope: $scope.$new()
                    });
                }]
        }
    }]);